import { toast } from 'react-toastify';
import { SR_STATUS } from 'src/pages/Property/CustomHooks/PropertyServiceRequests/constants';

export interface UseBulkStatusUpdateArgs {
  selectedIds: string[];
  buildStatusPayload: (status: string) => object;
  onAssignRequested: () => void;
  onDeclineRequested: () => void;
  updateStatus: (payload: object) => Promise<boolean>;
  refetch: () => Promise<void>;
}

export interface UseBulkStatusUpdateReturn {
  bulkUpdateStatus: (status: string) => Promise<void>;
}

export const useBulkStatusUpdate = ({
  selectedIds,
  buildStatusPayload,
  onAssignRequested,
  onDeclineRequested,
  updateStatus,
  refetch,
}: UseBulkStatusUpdateArgs): UseBulkStatusUpdateReturn => {
  const bulkUpdateStatus = async (status: string): Promise<void> => {
    if (selectedIds.length === 0) {
      toast.error('Please select at least one service request to update.', {
        autoClose: 6000,
        position: 'top-center',
      });
      return;
    }

    if (status === SR_STATUS.Assigned) {
      onAssignRequested();
      return;
    }

    if (status === SR_STATUS.Declined) {
      onDeclineRequested();
      return;
    }

    const payload: object = buildStatusPayload(status);

    const ok: boolean = await updateStatus(payload);

    if (ok) {
      await refetch();
    }
  };

  return { bulkUpdateStatus };
};